import React, { useEffect, useState } from 'react';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './ralColors.module.css';
import Dialog from '../components/Dialog';
import classNames from '../lib/util/classNames';

// Define family colors
const familyColors = [
    { name: 'yellow', color: '#ffff00' },
    { name: 'orange', color: '#ffa500' },
    { name: 'red', color: '#ff0000' },
    { name: 'blue', color: '#0000ff' },
    { name: 'brown', color: '#a52a2a' },
    { name: 'green', color: '#008000' },
    { name: 'gray', color: '#808080' },
    { name: 'black', color: '#000000' },
    { name: 'violet', color: '#800080' },
    { name: 'white', color: '#ffffff' }
];

const groupColorsByFamily = colors => {
    const groupedFamilies = {};

    colors.forEach(color => {
        const { family } = color;
        if (!groupedFamilies[family]) {
            groupedFamilies[family] = [];
        }
        groupedFamilies[family].push(color);
    });

    return groupedFamilies;
};

const RalColors = props => {
    const { title, type, colors, initialValue, onColorSelected } = props;

    const classes = useStyle(defaultClasses, props.classes);

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedColor, setSelectedColor] = useState(
        typeof initialValue == 'string' ? null : initialValue
    );
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedFamily, setSelectedFamily] = useState(null);

    console.log('xxx initial value', initialValue);

    // when filtering by color name, reset the selected family
    useEffect(() => {
        if (searchTerm.trim().length) {
            setSelectedFamily(null);
        }
    }, [searchTerm]);

    // when a family is selected, reset the search term
    useEffect(() => {
        if (selectedFamily) {
            setSearchTerm('');
        }
    }, [selectedFamily]);

    if (!colors || !colors.length) {
        return null;
    }

    // Group colors by family
    const colorFamilies = groupColorsByFamily(colors);

    // Filter colors based on the selected family and search term
    const filteredColors = (selectedFamily
        ? colorFamilies[selectedFamily]
        : colors
    ).filter(color => {
        const term = searchTerm.trim().toLowerCase();
        return (
            color.label.toLowerCase().includes(term) ||
            color.code.toLowerCase().includes(term)
        );
    });

    const familyList = familyColors.map(family => (
        <li
            key={family.name}
            onClick={() => setSelectedFamily(family.name)}
            className={classNames(
                classes.familyItem,
                selectedFamily === family.name
                    ? classes.familyItemSelected
                    : null
            )}
            style={{ backgroundColor: family.color }}
        />
    ));

    const colorsList = filteredColors.map(color => {
        const isColorSelected =
            selectedColor && selectedColor.code === color.code;

        return (
            <li key={color.code} className={classes.colorContainer}>
                <div
                    key={color.code}
                    onClick={() => {
                        setSelectedColor(color);
                    }}
                    className={classNames(
                        classes.colorItem,
                        isColorSelected ? classes.colorItemSelected : null
                    )}
                >
                    <span
                        className={classes.colorSwatch}
                        style={{
                            backgroundColor: color.value
                        }}
                    />
                </div>
                <div className={classes.valuecontrast}>
                    {color.label} {color.code}
                </div>
            </li>
        );
    });

    console.log('selected RAL color', selectedColor);

    return (
        <>
            <label
                className={classNames(classes.ralButton, classes.trigger)}
                onClick={() => {
                    setIsDialogOpen(true);
                }}
            >
                {/* ral color selected */}
                {initialValue &&
                typeof initialValue == 'object' &&
                initialValue.type == type ? (
                    <span
                        className={classNames(
                            classes.ralBgImageWithColor,
                            classes[`ralBgImage-${type}`]
                        )}
                        style={{
                            backgroundColor: initialValue.value
                        }}
                    >
                        <span className={classes.selectedvalues}>
                            {initialValue.custom
                                ? initialValue.label
                                : `${initialValue.label} ${initialValue.code}`}
                        </span>
                    </span>
                ) : (
                    <span
                        className={classNames(
                            classes.ralBgImage,
                            classes[`ralBgImage-${type}`]
                        )}
                    />
                )}
                <span>{title}</span>
                <span className={classes.infocolor} alt="kleurinformatie">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="icon-icon-A2I"
                    >
                        <circle
                            cx="11"
                            cy="11"
                            r="8"
                            fill="#FFFFFF"
                            opacity="0.6"
                        />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                </span>
            </label>

            <Dialog
                isOpen={isDialogOpen}
                title={_('Selecteer RAL kleur')}
                showCancelButton={true}
                scrollLock={false}
                shouldDisableConfirmButton={
                    !selectedColor && !searchTerm.trim().match(/^\w{2}/)
                }
                onConfirm={() => {
                    const searchTermColor = searchTerm.trim();
                    const isCustomColor =
                        !filteredColors.length &&
                        searchTermColor.match(/^\w{2}/);

                    if (isCustomColor) {
                        // create a fake color with the same shape as the others
                        const fakeCustomColor = {
                            code: searchTermColor,
                            label: 'RAL ' + searchTermColor,
                            price: colors[0].price,
                            techlabel: `RAL-${searchTermColor}`,
                            type,
                            custom: true,
                            value: '#fff' // default color for custom RAL
                        };

                        setSelectedColor(fakeCustomColor);
                        onColorSelected(fakeCustomColor);
                    } else {
                        let selectedColorFinal = selectedColor;

                        if (
                            !selectedColorFinal ||
                            selectedColorFinal.custom ||
                            (filteredColors.length &&
                                !filteredColors.find(
                                    color =>
                                        color.code == selectedColorFinal.code
                                ))
                        ) {
                            // if the selected color is not in the filtered colors, select the first one
                            selectedColorFinal = filteredColors[0];
                        }

                        setSelectedColor(selectedColorFinal);

                        onColorSelected(selectedColorFinal);
                    }

                    setIsDialogOpen(false);
                }}
                onCancel={() => {
                    setIsDialogOpen(false);
                }}
            >
                <div className={classes.layout}>
                    <div className={classes.leftColumn}>
                        {/* <p>RAL code</p> */}
                        <div className={classes.searchIcon}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="icon-icon-A2I"
                            >
                                <circle cx="11" cy="11" r="8" fill="none" />
                                <line x1="21" y1="21" x2="16.65" y2="16.65" />
                            </svg>
                        </div>
                        <input
                            type="search"
                            placeholder={_('Voer RAL code in...')}
                            className={classes.searchInput}
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value.trim())}
                        />
                        <p>Selecteer kleur:</p>
                        <div className={classes.familyAndColors}>
                            <ul className={classes.familyList}>{familyList}</ul>
                            <ul
                                className={classNames(
                                    classes.scrollableList,
                                    colorsList.length == 0 && classes.emptyList
                                )}
                            >
                                {colorsList}
                                {!colorsList.length &&
                                    (searchTerm.match(/^\w{2}/) ? (
                                        <>
                                            <li
                                                className={
                                                    classes.customRalText
                                                }
                                            >
                                                <p>
                                                    {_(
                                                        'U kunt {0} bestellen. Deze RAL code kan echter niet visueel worden weergegeven.',
                                                        <strong>
                                                            {searchTerm}
                                                        </strong>
                                                    )}
                                                </p>
                                                <p>
                                                    {_(
                                                        'Bevestig uw keuze om door te gaan.'
                                                    )}
                                                </p>
                                            </li>
                                        </>
                                    ) : (
                                        <li
                                            className={classNames(
                                                classes.noResults
                                            )}
                                        >
                                            Geen kleuren beschikbaar, type meer
                                            karakters om speciale RAL kleur toe
                                            te voegen.
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default RalColors;
